import React from 'react';
const Send = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g clipPath="url(#clip0_3351_23397)">
      <path d="M18.3332 1.6665L9.1665 10.8332"
        stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.3332 1.6665L12.4998 18.3332L9.1665 10.8332L1.6665 7.49984L18.3332 1.6665Z"
        stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3351_23397">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>

);


export default Send;